import { FunctionComponent } from 'react';
import { CellProps } from 'components/tables/cells';
import { getProductConfig } from 'domain/product/productMap';
import { HStack, Text } from '@montel/montelpro-shared-components-v2';
import { ProductIcon } from 'components/common/Product/ProductIcon/ProductIcon';
import VerticalStackCell from './VerticalStackCell';
import { PermissionSet } from 'domain/subscription/interfaces/Subscription';

export interface ApplicationCellProps extends CellProps {
	permissionSets: Record<string, PermissionSet>;
	iconsOnly?: boolean;
}

const ApplicationCell: FunctionComponent<ApplicationCellProps> = ({
	permissionSets,
	iconsOnly = false,
	...rest
}) => {
	const products = Object.keys(permissionSets).map((applicationId) =>
		getProductConfig(applicationId),
	);

	const appElements = products.map((item, i) => (
		<HStack align="center" key={i} wrap="nowrap">
			{item?.id && <ProductIcon productId={item?.id} />}
			{!iconsOnly && <Text size={'sm'}>{item?.name}</Text>}
		</HStack>
	));

	return iconsOnly ? (
		<HStack gap="xs" wrap="nowrap" align="center">
			{appElements}
		</HStack>
	) : (
		<VerticalStackCell {...rest}>{appElements}</VerticalStackCell>
	);
};

export default ApplicationCell;
